const NON_PARTICIPANT_ROLES = ["admin", "bot"];

// チャットの相手ユーザーの id を返す（既読表示の判定に使う）
// - ボットチャット・自分が管理者（相手が 2 人）の場合は null
// - 管理者は users の最後に入るため、候補の先頭を相手とする
export const getRecipientId = (chatInfo, selfId, isAdmin) => {
  if (!chatInfo?.isGroup || isAdmin) return null;
  const users = Array.isArray(chatInfo.users) ? chatInfo.users : [];
  const recipient = users.find(
    (user) =>
      user?.id &&
      user.id !== selfId &&
      !NON_PARTICIPANT_ROLES.includes(user.role),
  );
  return recipient ? recipient.id : null;
};

// 入力中のユーザーの表示名を、そのユーザーのメッセージの sender から求める
export const getTypingName = (messages, typingUserId) => {
  if (!typingUserId) return null;
  const list = Array.isArray(messages) ? messages : [];
  for (let i = list.length - 1; i >= 0; i -= 1) {
    if (list[i]?.senderId === typingUserId && list[i]?.sender) {
      return list[i].sender;
    }
  }
  return "相手";
};
